// Cart drawer: opens on add-to-cart / cart icon, re-renders via the Section Rendering API.
(function () {
  const SECTION_ID = 'cart-drawer';
  const root = () => document.querySelector('[data-cart-drawer]');

  function open() {
    const drawer = root();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('elv-drawer-open');
  }

  function close() {
    const drawer = root();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('elv-drawer-open');
  }

  function setLoading(isLoading) {
    const drawer = root();
    if (drawer) drawer.classList.toggle('is-loading', isLoading);
  }

  function updateCount(count) {
    document.querySelectorAll('.elv-header__cart').forEach((link) => {
      let badge = link.querySelector('.elv-header__count');
      if (count > 0 && !badge) {
        badge = document.createElement('span');
        badge.className = 'elv-header__count';
        link.appendChild(badge);
      }
      if (badge) {
        if (count > 0) badge.textContent = String(count);
        else badge.remove();
      }
      link.setAttribute('aria-label', 'Cart, ' + count + ' items');
    });
  }

  // Swap in freshly rendered drawer HTML while keeping it open.
  function render(sections) {
    const html = sections && sections[SECTION_ID];
    const current = root();
    if (!html || !current) return;
    const wasOpen = current.classList.contains('is-open');
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
    if (!fresh) return;
    if (wasOpen) {
      fresh.classList.add('is-open');
      fresh.setAttribute('aria-hidden', 'false');
    }
    current.replaceWith(fresh);
  }

  async function request(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: [SECTION_ID], sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Cart request failed');
    return data;
  }

  async function refreshCount() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    updateCount(cart.item_count);
  }

  async function addFromForm(form) {
    const formData = new FormData(form);
    const item = { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) };
    const plan = formData.get('selling_plan');
    if (plan) item.selling_plan = Number(plan);
    const data = await request('/cart/add.js', { items: [item] });
    render(data.sections);
    await refreshCount();
    open();
  }

  async function changeLine(key, quantity) {
    setLoading(true);
    try {
      const data = await request('/cart/change.js', { id: key, quantity });
      render(data.sections);
      updateCount(data.item_count);
    } finally {
      setLoading(false);
    }
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    if (event.submitter && event.submitter.name === 'checkout') return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"][name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');
    try {
      await addFromForm(form);
    } catch (error) {
      console.error('[cart-drawer] add failed', error);
      window.alert(error.message || 'Sorry, we could not add this item. Please try again.');
    } finally {
      if (button) button.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const opener = target.closest('[data-cart-open]');
    if (opener && root()) {
      event.preventDefault();
      open();
      return;
    }

    if (target.closest('[data-cart-close]')) {
      close();
      return;
    }

    const qty = target.closest('[data-cart-qty]');
    if (qty) {
      changeLine(qty.dataset.cartQty, Math.max(0, Number(qty.dataset.qty))).catch((error) => {
        console.error('[cart-drawer] change failed', error);
        window.alert('Sorry, we could not update your cart. Please refresh and try again.');
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
})();
